import { useState } from 'react';
import { useCart } from '../contexts/CartContext';
import type { Informacion } from '../api';

export default function CartDrawer({ info }: { info: Informacion | null }) {
  const { items, changeQty, total, isOpen, closeCart, clearCart } = useCart();
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [enviando, setEnviando] = useState(false);

  const confirmar = async () => {
    if (!nombre.trim() || items.length === 0) return;
    setEnviando(true);

    try {
      await fetch('/api/pedidos/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre_cliente: nombre,
          telefono,
          items: items.map(i => ({ nombre: i.nombre, cantidad: i.cantidad, precio: i.precio })),
          total,
        }),
      });
    } catch {
      // aunque falle el registro en el panel, igual dejamos que el pedido
      // se mande por WhatsApp -- no queremos bloquear al cliente por eso
    }

    const detalle = items.map(i => `• ${i.nombre} x${i.cantidad} — ₡${(i.precio * i.cantidad).toLocaleString()}`).join('%0A');
    const mensaje = `¡Hola Soda Celes! 👋 Soy ${nombre}, quiero pedir:%0A${detalle}%0A%0ATotal: ₡${total.toLocaleString()}`;
    const numero = info?.whatsapp || '';

    setEnviando(false);
    if (numero) {
      window.open(`https://wa.me/${numero}?text=${mensaje}`, '_blank');
    }
    clearCart();
    setNombre('');
    setTelefono('');
    closeCart();
  };

  return (
    <>
      <div
        onClick={closeCart}
        className={`fixed inset-0 bg-wine-darker/55 z-[199] transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
      />
      <div className={`fixed top-0 right-0 h-full w-[400px] max-w-[90vw] bg-cream z-[200] flex flex-col shadow-2xl transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="bg-wine-darker text-white px-6 py-6 flex justify-between items-center">
          <h3 className="font-display text-xl">🛒 Tu Pedido</h3>
          <button onClick={closeCart} className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-5">
          {items.length === 0 ? (
            <div className="text-center text-ink/40 py-16 text-sm">Todavía no agregaste nada del menú 🍽️</div>
          ) : (
            items.map(i => (
              <div key={i.id} className="flex items-center gap-3 py-3 border-b border-cream-dark">
                <div className="flex-1">
                  <h5 className="text-sm font-semibold text-wine-darker">{i.nombre}</h5>
                  <span className="text-xs text-wine font-bold">₡{(i.precio * i.cantidad).toLocaleString()}</span>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={() => changeQty(i.id, -1)} className="w-6 h-6 rounded-md bg-cream-dark text-wine-darker text-sm">−</button>
                  <span className="text-sm w-4 text-center">{i.cantidad}</span>
                  <button onClick={() => changeQty(i.id, 1)} className="w-6 h-6 rounded-md bg-cream-dark text-wine-darker text-sm">+</button>
                </div>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className="px-6 pt-4 pb-7 border-t border-cream-dark">
            <input value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Tu nombre *"
              className="w-full mb-2 px-3 py-2.5 rounded-lg border border-cream-dark text-sm" />
            <input value={telefono} onChange={e => setTelefono(e.target.value)} placeholder="Teléfono (opcional)"
              className="w-full mb-4 px-3 py-2.5 rounded-lg border border-cream-dark text-sm" />

            <div className="flex justify-between items-baseline mb-4">
              <span className="text-sm text-ink/60">Total</span>
              <span className="font-display text-2xl font-extrabold text-wine">₡{total.toLocaleString()}</span>
            </div>
            <button onClick={confirmar} disabled={!nombre.trim() || enviando}
              className="w-full bg-whatsapp hover:bg-[#1fb955] disabled:opacity-50 text-white font-bold text-sm py-4 rounded-2xl flex items-center justify-center gap-2 transition-colors">
              {enviando ? 'Enviando...' : '💬 Confirmar por WhatsApp'}
            </button>
          </div>
        )}
      </div>
    </>
  );
}
